import React from 'react';

import { useIntl } from 'react-intl';
import { CSSEmptyWrapper, CSSPlaceholder } from './styles';

type JRCWidgetEmptyInplaceProps = {
    url: string;
    label: string;
    description: string;
    onClick: () => void;
};

export const JRCWidgetEmptyInplace = ({ url, label, description, onClick }: JRCWidgetEmptyInplaceProps) => {
    const intl = useIntl();
    return (
        <CSSEmptyWrapper>
            <CSSPlaceholder onClick={onClick}>
                <img src={`/img/applications/articleWidgets/${url}`} alt="" />
                <b>{intl.formatMessage({ id: label })}</b>
                <i>{intl.formatMessage({ id: description })}</i>
            </CSSPlaceholder>
        </CSSEmptyWrapper>
    );
};
